import './spinner.scss'
import PropTypes from 'prop-types'

const Spinner = ({ className = '' }) => {
  return (
  <div className={`simple-spinner ${className}`}>
  <span></span>
  </div>
  )
}

Spinner.propTypes = {
  className: PropTypes.string
}

export default Spinner
